export default __webpack_public_path__ + "static/media/img2.bb726938.jpeg";